(function(){
function init(){
  var box=document.querySelector('.shopify-policy__container');if(!box||box.__pe)return;box.__pe=1;
  var h1=box.querySelector('.shopify-policy__title h1'),rte=box.querySelector('.shopify-policy__body .rte');if(!h1||!rte)return;
  var root=rte.querySelector('.privacy-vsb')||rte,kids=[].slice.call(root.children),upd='',secs=[],cur=null;
  kids.forEach(function(k){
    if(k.tagName==='H2'){cur={title:k.textContent.trim(),els:[]};secs.push(cur)}
    else if(!cur){var t=k.textContent.trim();if(/^last updated/i.test(t)&&!upd){upd=t}else if(t){cur={title:null,els:[k]};secs.push(cur)}}
    else cur.els.push(k);
  });
  var titled=secs.filter(function(s){return s.title});
  var sec=document.createElement('section');sec.className='pg pg--policy';
  var h='<div class="pg-in"><header class="pg-head"><p class="pg-label">Legal</p><h1 class="pg-h"></h1>'+(upd?'<p class="pg-upd"></p>':'')+'</header><div class="pg-grid"><nav class="pg-toc" aria-label="On this page" data-dg-clear'+(titled.length>1?'':' hidden')+'></nav><div class="pg-body rte" data-dg-clear></div></div></div>';
  sec.innerHTML=h;
  sec.querySelector('.pg-h').textContent=h1.textContent.trim().replace(/^./,function(c){return c.toUpperCase()});
  if(upd)sec.querySelector('.pg-upd').textContent=upd.replace(/^last updated:?\s*/i,'Last updated ');
  var body=sec.querySelector('.pg-body'),toc=sec.querySelector('.pg-toc'),links=[];
  secs.forEach(function(s){
    var d=document.createElement('section');d.className='pg-sec';
    if(s.title){var n=titled.indexOf(s)+1,id='p'+n;d.id=id;var hh=document.createElement('h2');hh.className='pg-sh';hh.textContent=s.title;d.appendChild(hh);links.push({id:id,t:s.title,n:n})}
    s.els.forEach(function(e){d.appendChild(e)});body.appendChild(d);
  });
  toc.innerHTML=links.map(function(l){return '<a href="#'+l.id+'">'+l.t.replace(/</g,'&lt;')+'</a>'}).join('');
  box.parentNode.replaceChild(sec,box);
  var as=[].slice.call(toc.querySelectorAll('a'));
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)as.forEach(function(a){a.classList.toggle('is-on',a.getAttribute('href')==='#'+e.target.id)})})},{rootMargin:'-20% 0px -70% 0px'});
  body.querySelectorAll('.pg-sec[id]').forEach(function(s){io.observe(s)});
  if(window.ThirtyDotGrid&&ThirtyDotGrid.refresh)ThirtyDotGrid.refresh();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
